import React, { useState, useEffect } from "react";

export default function Banner({
  images = [],
  text = "Banner Text",
  autoPlayInterval = 3000,
}) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, autoPlayInterval);
    }
    return () => clearInterval(interval);
  }, [isPlaying, autoPlayInterval, images.length]);

  const goToImage = (index) => {
    setCurrentImageIndex(index);
    setIsPlaying(false); // Detener autoplay al navegar manualmente
  };

  const togglePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="relative h-80 w-full overflow-hidden md:h-96 lg:h-[500px]">
      {/* Imagen de fondo */}
      {images.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`Slide ${index}`}
          className={`absolute left-0 top-0 h-full w-full object-cover transition-opacity duration-1000 ${index === currentImageIndex ? "opacity-100" : "opacity-0"}`}
        />
      ))}

      {/* Texto centrado */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="rounded-lg bg-black bg-opacity-50 px-4 py-2 text-2xl font-semibold text-white md:text-3xl lg:text-4xl">
          {text}
        </div>
      </div>

      {/* Controles de navegación */}
      <div className="absolute bottom-4 flex w-full items-center justify-center space-x-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => goToImage(index)}
            className={`h-3 w-3 rounded-full md:h-4 md:w-4 ${index === currentImageIndex ? "bg-white" : "bg-gray-500"} focus:outline-none`}
          ></button>
        ))}
      </div>

      {/* Botón Play/Pausa */}
      <button
        onClick={togglePlayPause}
        className="absolute bottom-4 right-4 rounded-full bg-black bg-opacity-50 p-2 text-white hover:bg-opacity-75"
        aria-label={isPlaying ? "Pause slideshow" : "Play slideshow"}
      >
        {isPlaying ? "⏸" : "▶️"}
      </button>
    </div>
  );
}
